<template>
  <div class="headers">
    <div class="top">
      <div class="w">
        <div class="l">
          <!-- 欢迎光临天相财富官方网站！
          证监会授权经营证券期货业务许可机构（投资咨询）编号：0110 -->
        </div>
        <div class="r">
          <!-- <div class="lis1">
            <img src="../assets/img/phone1.png" alt="" />
            <span>申诉电话：400-****-****</span>
          </div> -->
          <div class="lis2">
            <img src="../assets/img/phone2.png" alt="" />
            <span>咨询热线：010-66045050</span>
            <!-- 4008-562-881 -->
          </div>
          <div class="lis2">
            <img src="../assets/img/phone2.png" alt="" />
            <span>申诉热线：400-101-8662</span>
            <!-- 4008-562-881 -->
          </div>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="w">
        <div class="l">
          <img src="../assets/img/index/header/022.png" alt="" />
        </div>
        <div class="r" id="livst">
          <el-menu
            style="border-bottom: none; font-weight: 600"
            text-color="#222222"
            active-text-color="#d5352e"
            :default-active="$route.name"
            :router="true"
            class="el-menu-vertical-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              style="margin-right: 20px"
              index="index"
              :route="{ path: '/' }"
            >
              首页
            </el-menu-item>

            <el-menu-item
              style="margin-right: 20px"
              index="product"
              :route="{ path: '/product' }"
            >
              产品中心
            </el-menu-item>
            <!-- <el-menu-item style="margin-right: 20px" @click="to_xaizai"
              >产品下载</el-menu-item
            > -->
            <el-submenu style="margin-right: 20px" index="">
              <template slot="title">产品下载</template>
              <el-menu-item @click="to_xaizai1()">下载地址一</el-menu-item>
              <el-menu-item @click="to_xaizai2()">下载地址二</el-menu-item>
            </el-submenu>
            <el-menu-item
              style="margin-right: 20px"
              index="userService"
              :route="{ path: '/userService' }"
            >
              用户服务
            </el-menu-item>
            <!-- <el-menu-item style="margin-right: 20px" index="productCenter" :route="{ path: '/productCenter' }">
              投顾团队
            </el-menu-item> -->
            <el-menu-item
              style="margin-right: 20px"
              index="aboutUs"
              :route="{ path: '/aboutUs' }"
            >
              关于我们
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headers",
  data() {
    return {
      activeIndex: "1",
      tilte: 0,
    };
  },
  computed: {},
  methods: {
    handleSelect(index) {
      this.tilte = index;
    },
    to_xaizai1() {
      window.open("https://cdn.juniubang.com/apk/GDD1003.exe");
    },
    to_xaizai2() {
      window.open("https://ins.juniubang.com/images/GDD2015.exe");
    },
  },
};
</script>

<style  scopen lang="less">
// .r li{
//   border-bottom-color:red !important;
// }
// .r a.router-link-exact-active{
//     /* 路由点击后的样式 */
//     /* 添加需要的样式 */
//     color:red !important
// }
// .r a{
//   color:#333333 !important;
// }
.top {
  width: 100%;
  height: 42px;
  background-color: #f3f4f6;

  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #555555;

    .r {
      height: 42px;
      display: flex;
      align-items: center;
      .lis1 {
        img {
          width: 19px;
          height: 16px;
          margin-right: 10px;
        }
        display: flex;
        align-items: center;
      }
      .lis2 {
        margin-left: 20px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
        display: flex;
        align-items: center;
      }
    }
  }
}
.nav {
  width: 100%;
  height: 80px;
  .w {
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-menu-demo {
      font-weight: 600;
    }
    .el-menu-item.is-active {
      border-bottom: 3px solid;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue